(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bhp-timer"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('bhp-clock')){
  customElements.define('bhp-clock',class extends HTMLElement{
    connectedCallback(){
      if(this.interval)return;
      this.parts=Object.fromEntries([...this.querySelectorAll('[data-bhp-unit]')].map(el=>[el.dataset.bhpUnit,el]));
      this.controller=new AbortController();
      this.update=()=>{
        const opening=document.querySelector('[data-bhp-opening]')?.dataset.bhpOpening||this.dataset.opening;
        const target=Date.parse(opening);if(!Number.isFinite(target))return;
        const total=Math.max(0,Math.ceil((target-Date.now())/1000));
        const values={days:Math.floor(total/86400),hours:Math.floor(total%86400/3600),minutes:Math.floor(total%3600/60),seconds:total%60};
        for(const [key,value] of Object.entries(values)){const next=String(value).padStart(2,'0');if(this.parts[key]?.textContent!==next)this.parts[key].textContent=next;}
        if(total===0){this.hidden=true;this.closest('[data-bhp-banner]')?.querySelectorAll('[data-bhp-label]').forEach(el=>el.textContent=this.dataset.started);}
      };
      this.update();this.interval=setInterval(()=>{if(!document.hidden)this.update()},1000);
      document.addEventListener('visibilitychange',this.update,{signal:this.controller.signal});
      document.addEventListener('shopify:section:load',this.update,{signal:this.controller.signal});
    }
    disconnectedCallback(){clearInterval(this.interval);this.interval=null;this.controller?.abort();}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["chase-fulfillment-assets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('chase-fulfillment-notice')) {
    class ChaseFulfillmentNotice extends HTMLElement {
      static coordinates = null;
      static locationRequest = null;
      static locationPending = false;
      static locationStorageKey = 'chase:store-location:v1';
      static distance(origin, latitude, longitude) {
        const radians=value=>value*Math.PI/180;
        const deltaLatitude=radians(latitude-origin.latitude);
        const deltaLongitude=radians(longitude-origin.longitude);
        const a=Math.sin(deltaLatitude/2)**2+Math.cos(radians(origin.latitude))*Math.cos(radians(latitude))*Math.sin(deltaLongitude/2)**2;
        return 6371*2*Math.atan2(Math.sqrt(a),Math.sqrt(Math.max(0,1-a)));
      }
      connectedCallback() {
        if (this.dataset.compact) {
          if (this.dataset.hydrate) this.hydratePickup();
          else this.rememberText();
          return;
        }
        this.productInfo=this.closest('product-info');
        this.onInput=event=>{
          if(event.target.matches('input[name="quantity"]')) this.updateQuantity();
        };
        this.onClick=event=>{
          if(event.target.closest('[data-locate]')) this.locateStores(true);
        };
        this.productInfo?.addEventListener('change',this.onInput);
        this.addEventListener('click',this.onClick);
        this.rememberText();
      }
      async hydratePickup() {
        try {
          const response=await fetch(this.dataset.availabilityUrl,{credentials:'same-origin'});
          if(!response.ok) return;
          const html=new DOMParser().parseFromString(await response.text(),'text/html');
          if(!this.isConnected) return;
          const source=html.querySelector('template[data-chase-cart-fulfillment]')?.content.querySelector('chase-fulfillment-notice');
          if(!source) return;
          this.innerHTML=source.innerHTML;
          for(const key of ['state','shippingQuantity','shippingKnown','hasStores','storePurchase']) this.dataset[key]=source.dataset[key];
          this.hidden=source.hidden;
          this.rememberText();
        } catch {}
      }
      disconnectedCallback() {
        this.productInfo?.removeEventListener('change',this.onInput);
        this.removeEventListener('click',this.onClick);
      }
      rememberText() {
        this.baseTitle=this.querySelector('[data-fulfillment-title]')?.textContent;
        this.baseBody=this.querySelector('[data-fulfillment-body]')?.textContent;
        this.baseState=this.dataset.state;
        this.baseHidden=this.hidden;
        this.updateQuantity();
        this.syncPurchaseControls();
        if(location.hash === '#chase-store-contact-'+this.dataset.availabilityUrl.split('/variants/')[1]?.split('/')[0]) this.openStores();
        const locateButton=this.querySelector('[data-locate]');
        if(locateButton && !this.dataset.compact) locateButton.hidden=false;
      }
      syncPurchaseControls() {
        if(this.dataset.compact) return;
        const form=this.closest('product-form');
        const controls=form?.querySelector('[data-chase-purchase-controls]');
        if(!form || !controls) return;
        const storeOnly=this.dataset.storePurchase==='true';
        form.dataset.chaseStorePurchase=String(storeOnly);
        controls.hidden=storeOnly;
        const afterCart=this.dataset.shippingKnown==='true' && Number(this.dataset.shippingQuantity)>0;
        this.dataset.placement=afterCart ? 'after' : 'before';
        if(afterCart && controls.nextElementSibling!==this) controls.after(this);
        else if(!afterCart && this.nextElementSibling!==controls) controls.before(this);
      }
      openStores() {
        const details=this.querySelector('.chase-fulfillment__stores');
        if(!details) return;
        details.open=true;
        details.querySelector('summary')?.focus();
      }
      updateQuantity() {
        const quantity=Number(this.dataset.compact ? this.dataset.quantity : this.productInfo?.querySelector('input[name="quantity"]')?.value || 1);
        const limited=this.dataset.shippingKnown==='true' && Number(this.dataset.shippingQuantity)>0 && quantity>Number(this.dataset.shippingQuantity);
        const title=this.querySelector('[data-fulfillment-title]');
        const body=this.querySelector('[data-fulfillment-body]');
        if(title) title.textContent=limited ? this.dataset.quantityTitle : this.baseTitle;
        if(body) body.textContent=limited ? this.dataset.quantityBody : this.baseBody;
        this.dataset.state=limited ? 'quantity' : this.baseState;
        this.hidden=limited ? false : this.baseHidden;
      }
      static validCoordinates(coordinates) {
        return coordinates && Number.isFinite(coordinates.latitude) && Number.isFinite(coordinates.longitude) && Math.abs(coordinates.latitude)<=90 && Math.abs(coordinates.longitude)<=180;
      }
      static readLocationSession() {
        try {
          const saved=sessionStorage.getItem(this.locationStorageKey);
          if(saved===null) return null;
          const state=JSON.parse(saved);
          if(state?.version===1 && state.status==='granted' && this.validCoordinates(state.coordinates)) return {coordinates:state.coordinates};
          return {error:{code:state?.status==='denied' ? 1 : 2}};
        } catch { return {error:{code:2}}; }
      }
      static saveLocationSession(state) {
        try {
          sessionStorage.setItem(this.locationStorageKey,JSON.stringify({version:1,...state}));
          return true;
        } catch { return false; }
      }
      static requestLocation(retry=false) {
        if(this.locationPending) return this.locationRequest;
        if(!retry) {
          if(this.coordinates) return Promise.resolve({coordinates:this.coordinates});
          if(this.locationRequest) return this.locationRequest;
          const saved=this.readLocationSession();
          if(saved) {
            this.coordinates=saved.coordinates || null;
            this.locationRequest=Promise.resolve(saved);
            return this.locationRequest;
          }
        }
        const persisted=this.saveLocationSession({status:'pending'});
        if(!persisted && !retry) {
          this.locationRequest=Promise.resolve({error:{code:2}});
          return this.locationRequest;
        }
        this.coordinates=null;
        this.locationPending=true;
        this.locationRequest=new Promise(resolve=>{
          const finish=result=>{
            this.locationPending=false;
            this.saveLocationSession(result.coordinates ? {status:'granted',coordinates:result.coordinates} : {status:result.error.code===1 ? 'denied' : 'unavailable'});
            resolve(result);
          };
          const failure=error=>finish({error:{code:error?.code===1 ? 1 : 2}});
          if(!navigator.geolocation) return failure({code:2});
          try {
            navigator.geolocation.getCurrentPosition(position=>{
              const coordinates={latitude:position.coords.latitude,longitude:position.coords.longitude};
              if(!this.validCoordinates(coordinates)) return failure({code:2});
              this.coordinates=coordinates;
              finish({coordinates});
            },failure,{enableHighAccuracy:false,timeout:10000,maximumAge:300000});
          } catch(error) { failure(error); }
        });
        return this.locationRequest;
      }
      async locateStores(retry=false) {
        const button=this.querySelector('[data-locate]');
        const status=this.querySelector('[data-location-status]');
        if(!button || !status || button.disabled) return;
        button.disabled=true;
        button.hidden=true;
        status.textContent=this.dataset.locating;
        const result=await ChaseFulfillmentNotice.requestLocation(retry);
        if(!this.isConnected || !button.isConnected) return;
        button.disabled=false;
        if(result.coordinates) {
          this.sortStores(result.coordinates);
        } else {
          status.textContent=result.error?.code===1 ? this.dataset.locationDenied : this.dataset.locationUnavailable;
          button.hidden=false;
        }
      }
      sortStores(origin) {
        const list=this.querySelector('[data-store-list]');
        if(!list) return;
        const stores=Array.from(list.querySelectorAll('[data-store]')).map((item,index)=>{
          const latitude=Number(item.dataset.latitude);
          const longitude=Number(item.dataset.longitude);
          const valid=item.dataset.latitude?.trim() && item.dataset.longitude?.trim() && Number.isFinite(latitude) && Number.isFinite(longitude) && Math.abs(latitude)<=90 && Math.abs(longitude)<=180;
          return {item,index,distance:valid ? ChaseFulfillmentNotice.distance(origin,latitude,longitude) : Infinity};
        }).sort((a,b)=>a.distance-b.distance || a.index-b.index);
        let known=0;
        stores.forEach(({item,distance})=>{
          const nearest=item.querySelector('[data-nearest]');
          const label=item.querySelector('[data-distance-label]');
          const valid=Number.isFinite(distance);
          if(nearest) nearest.hidden=!valid || known>0;
          if(label) {
            label.hidden=!valid;
            if(valid) label.textContent=this.dataset.distance.replace('[distance]',new Intl.NumberFormat(document.documentElement.lang || 'pt-BR',{maximumFractionDigits:1}).format(distance));
          }
          if(valid) known++;
          list.appendChild(item);
        });
        const status=this.querySelector('[data-location-status]');
        if(status) status.textContent=known ? this.dataset.locationSorted : this.dataset.locationUnavailable;
      }
    }
    customElements.define('chase-fulfillment-notice',ChaseFulfillmentNotice);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["chase-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('chase-size-guide')) {
    customElements.define('chase-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        const dialog = this.querySelector('dialog');
        if (!dialog || typeof dialog.showModal !== 'function') return;
        this.ready = true;
        const trigger = this.querySelector('.chase-size-guide__trigger');
        const content = this.querySelector('.chase-size-guide__content');
        dialog.append(content);
        trigger.setAttribute('role', 'button');
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.addEventListener('click', event => {
          event.preventDefault();
          dialog.showModal();
          dialog.scrollTop = 0;
          trigger.setAttribute('aria-expanded', 'true');
          document.documentElement.classList.add('chase-size-guide-open');
        });
        this.querySelector('.chase-size-guide__close').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => {
          trigger.setAttribute('aria-expanded', 'false');
          document.documentElement.classList.remove('chase-size-guide-open');
          if (trigger.isConnected) trigger.focus({ preventScroll: true });
        });
      }
      disconnectedCallback() {
        if (this.querySelector('dialog[open]')) document.documentElement.classList.remove('chase-size-guide-open');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
